(function () {
  var ENTRANCE_DELAY_MS = 5000;
  var PAUSE_AFTER_ENTRANCE_MS = 2000;
  var ENTRANCE_ANIMATION_MS = 650;
  var EXPAND_TRANSITION_MS = 550;
  var AUTO_COLLAPSE_AFTER_EXPAND_MS = 10000;

  function initWhatsAppWidget() {
    var widget = document.getElementById('whatsapp-chat-widget');
    if (!widget || widget.dataset.initialized === 'true') return;

    var link = widget.querySelector('.whatsapp-chat-widget__link');
    var panel = widget.querySelector('.whatsapp-chat-widget__panel');
    if (!link || !panel) return;

    widget.dataset.initialized = 'true';

    var autoCollapseTimer = null;
    var isPointerInside = false;

    function expand() {
      widget.classList.add('is-expanded');
    }

    function collapse() {
      widget.classList.remove('is-expanded');
    }

    function clearAutoCollapse() {
      if (autoCollapseTimer !== null) {
        window.clearTimeout(autoCollapseTimer);
        autoCollapseTimer = null;
      }
    }

    function runAutoCollapseIfAllowed() {
      if (isPointerInside) return;
      collapse();
    }

    function scheduleInitialAutoCollapse() {
      clearAutoCollapse();

      autoCollapseTimer = window.setTimeout(function () {
        autoCollapseTimer = null;
        runAutoCollapseIfAllowed();
      }, AUTO_COLLAPSE_AFTER_EXPAND_MS);
    }

    function afterExpandSettled(callback) {
      var done = false;

      function finish() {
        if (done) return;
        done = true;
        panel.removeEventListener('transitionend', onTransitionEnd);
        callback();
      }

      function onTransitionEnd(event) {
        if (event.target !== panel || event.propertyName !== 'max-width') return;
        finish();
      }

      panel.addEventListener('transitionend', onTransitionEnd);
      window.setTimeout(finish, EXPAND_TRANSITION_MS + 50);
    }

    link.addEventListener('mouseenter', function () {
      isPointerInside = true;
      clearAutoCollapse();
      expand();
    });

    link.addEventListener('mouseleave', function () {
      isPointerInside = false;
      collapse();
    });

    window.setTimeout(function () {
      widget.classList.add('is-entered');
      widget.setAttribute('aria-hidden', 'false');

      window.setTimeout(function () {
        expand();
        afterExpandSettled(scheduleInitialAutoCollapse);
      }, PAUSE_AFTER_ENTRANCE_MS + ENTRANCE_ANIMATION_MS);
    }, ENTRANCE_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhatsAppWidget);
  } else {
    initWhatsAppWidget();
  }
})();
